// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"NotFound_mainContainer__2Y0kA","mainText":"NotFound_mainText__zR8bN","subText":"NotFound_subText__3qHbX","returnButton":"NotFound_returnButton__24ehO"};